import { useMemo } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { errorToast } from "@/v2-ui/toast"
import Page, { type PageProps } from "@/v2-backoffice-client/components/page"
import CustomerTable from "@/v2-backoffice-client/customer/CustomerTable"
import { useCustomerCountsQuery } from "@/v2-backoffice-client/customer/counts/customer.counts.query"
import CustomerCreateButton from "@/v2-backoffice-client/customer/create/CustomerCreateButton"
import LicensePlaybookLink from "@/v2-backoffice-client/license/LicensePlaybookLink"

export type CustomerPageProps = PageProps

function CustomerPage(props: CustomerPageProps) {
  const { className, ...pageProps } = props

  // Customers per governing license status (0 = no license), feeding the
  // board's status pills, plus the over-seat-cap count behind the Over
  // seats pill.
  const { data, loading, error } = useCustomerCountsQuery()
  const buckets = data?.getCustomerCounts.byLicenseStatus
  const overSeatCapCount = data?.getCustomerCounts.overSeatCap
  const statusCounts = useMemo(() => {
    if (!buckets) return undefined
    return new Map(
      buckets.map((bucket) => [bucket.LicenseStatusCode, bucket.CustomerCount]),
    )
  }, [buckets])

  errorToast(error, {
    title: "Failed to query for customer counts",
  })

  return (
    <Page className={cn("customer-page", className)} {...pageProps}>
      <Page.Header>
        <Page.Title>Customers</Page.Title>
        <Page.Header.Actions>
          {/* The playbook sits where the licensing work starts: giving a
              customer access happens from this board's panels. */}
          <LicensePlaybookLink />
          <CustomerCreateButton />
        </Page.Header.Actions>
      </Page.Header>

      <Page.Content>
        <CustomerTable
          isLoading={loading}
          statusCounts={statusCounts}
          overSeatCapCount={overSeatCapCount}
        />
      </Page.Content>
    </Page>
  )
}

export default CustomerPage
